import React from 'react';
import moment from 'moment';

import styles from './chartTooltipIdeaUpdateStyles';

import AnonymousUserDisplay from 'buyside/components/presentation/AnonymousUserDisplay/anonymousUserDisplay';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';
import Link from 'buyside/components/presentation/Link/link';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Icon from 'buyside/components/presentation/Icon/icon';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';

import ThumbsUpIcon from 'buyside/svgs/thumbs_up.svg';
import ScaleIcon from 'buyside/svgs/scale.svg';
import ThumbsDownIcon from 'buyside/svgs/thumbs_down.svg';
import BlockedIcon from 'buyside/svgs/blocked.svg';

import { get } from 'buyside/util/lodashAltJs';
import { ideaUrl, userUrl } from 'buyside/util/urlHelper';
import separateWithDots from 'buyside/util/separateWithDots';

const ChartTooltipIdeaUpdate = ({ ideaUpdate, showUserDetails }) => {
  const { idea, createdAt, closed, impact, text } = ideaUpdate;

  const { id, positions, user } = idea;

  const date = moment(createdAt);
  const daysAgo = moment().diff(date, 'days');

  const actionVerb = closed ? 'closed' : 'updated';

  const ideaUpdateImpact = impact => {
    if (closed === true) {
      impact = 'closed';
    }

    const texts = {
      positive: 'Positive Update on Position',
      neutral: 'Neutral Update on Position',
      negative: 'Negative Update on Position',
      closed: 'Closed Position'
    };

    const impactIcons = {
      positive: ThumbsUpIcon,
      neutral: ScaleIcon,
      negative: ThumbsDownIcon,
      closed: BlockedIcon
    };

    const colorClasses = {
      positive: 'green',
      neutral: 'blue',
      negative: 'red',
      closed: 'red'
    };

    const textColor = closed ? 'gray' : styles[colorClasses[impact]];

    return (
      <div className={styles.ideaUpdateSentiment}>
        <Icon
          type={impactIcons[impact]}
          className={`${styles[colorClasses[impact]]} ${styles.ideaUpdateSentimentIcon}`}
        />
        <strong className={textColor}>{texts[impact]}</strong>
      </div>
    );
  };

  const redacted = (text || '').slice(0, 8) === 'redacted';

  return (
    <div className={styles.ideaTooltip}>
      <div className={styles.ideaTooltipHeader}>
        <strong>{separateWithDots(positions.map(position => position.asset.primarySymbol))}</strong>{' '}
        Idea {actionVerb} on {date.format('M/D/YY')}
      </div>
      <div className={styles.contentArea}>
        <ProfileImage
          source={showUserDetails ? user.profileImageUrl : ''}
          size="tiny"
          style={styles.profileImage}
        />
        <section>
          <div className={styles.displayName}>
            {showUserDetails ? (
              <Link to={userUrl(user.id)}>{user.displayName}</Link>
            ) : (
              <AnonymousUserDisplay
                anonUser={{ title: get(user, 'mostRecentEmployer.title', '') }}
              />
            )}
          </div>
          <div className={styles.postedDate}>
            {actionVerb} {daysAgo} day{daysAgo === 1 ? '' : 's'} ago
          </div>
          {(impact || closed) && (
            <div className={styles.updateImpact}>{ideaUpdateImpact(impact)}</div>
          )}
          {redacted ? (
            <RedactedDataPoint Wrapper="div" />
          ) : (
            <div className={styles.updateImpact}>
              {text
                ? text
                    .split(' ')
                    .splice(0, 10)
                    .join(' ') + '...'
                : ''}
            </div>
          )}
          <div className={styles.ideaButton}>
            <Button
              type={BUTTON_TYPES.PRIMARY}
              size={BUTTON_SIZES.TINY}
              url={ideaUrl(id)}
              text="View Idea"
            />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ChartTooltipIdeaUpdate;
